/* Black Friday 2026 — countdown „Oferta expiră în” → 10 nov 2026, 23:59:59 (Europe/Bucharest). */
(function () {
  var DEF_END = '2026-11-10T23:59:59+02:00';
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-bf-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-end') || DEF_END);
      if (isNaN(end)) end = Date.parse(DEF_END);
      var live = now <= end;
      el.setAttribute('data-bf-state', live ? 'live' : 'ended');
      var diff = live ? Math.max(0, Math.floor((end - now) / 1000)) : 0;
      var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
      var set = function (sel, v) { el.querySelectorAll(sel).forEach(function (n) { if (n.textContent !== v) n.textContent = v; }); };
      set('[data-bf-d]', pad(d)); set('[data-bf-h]', pad(h)); set('[data-bf-m]', pad(m)); set('[data-bf-s]', pad(s));
      set('[data-bf-label]', live ? 'Oferta expiră în' : 'Oferta s-a încheiat');
    });
  }
  function init() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', tick);
})();

/* Black Friday 2026 — reveal la scroll (respectă prefers-reduced-motion) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('bf-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan() { document.querySelectorAll('[data-bf-reveal]:not(.is-in)').forEach(function (el) { io.observe(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  /* plasă de siguranță: nimic nu rămâne ascuns */
  window.addEventListener('load', function () { setTimeout(function () { document.querySelectorAll('[data-bf-reveal]').forEach(function (el) { el.classList.add('is-in'); }); }, 6000); });
})();

/* Black Friday 2026 — „Comandă acum” coboară lin la colecții */
(function () {
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#colectii"]');
    if (!a) return;
    var t = document.getElementById('colectii');
    if (!t) return;
    ev.preventDefault();
    var header = document.querySelector('.header-wrapper');
    var off = header ? Math.min(header.getBoundingClientRect().height, 120) + 10 : 80;
    var y = t.getBoundingClientRect().top + window.pageYOffset - off;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#colectii');
  });
})();

/* Black Friday 2026 — cardurile de ofertă duc garantat la colecția lor
   (alte scripturi din temă/aplicații nu mai pot intercepta click-ul). */
(function () {
  window.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-bf-link]');
    if (!a || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    ev.stopImmediatePropagation();
    ev.preventDefault();
    window.location.assign(a.href);
  }, true);
})();

/* Black Friday 2026 — Evaluare: cadoul (pachetul cu 60 teste, linie cu _bf_kind=en) are mereu
   aceeași cantitate ca pachetul cu materie din coș. Dacă pachetul e scos/micșorat, cadoul se ajustează
   (altfel cadoul în plus s-ar plăti întreg). Nu ADAUGĂ niciodată cadou nou; doar corectează linia existentă. */
(function () {
  if (!window.fetch || window.__bfEvalSync) return; window.__bfEvalSync = true;
  var R = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var origFetch = window.fetch.bind(window), timer = null, running = false;
  function hdrs() { return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-BF-Sync': '1' }; }
  function refreshUI() {
    if (/\/cart\/?$/.test(location.pathname)) { var k = 'bfEvalSyncReload', t = 0; try { t = +sessionStorage.getItem(k) || 0; } catch (e) {} if (Date.now() - t > 15000) { try { sessionStorage.setItem(k, Date.now()); } catch (e) {} location.reload(); } return; }
    origFetch(R + '/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var P = new DOMParser();
      if (s['cart-drawer']) {
        var nd = P.parseFromString(s['cart-drawer'], 'text/html');
        var a = nd.querySelector('#CartDrawer'), b = document.querySelector('#CartDrawer');
        if (a && b) b.innerHTML = a.innerHTML;
        var ncd = nd.querySelector('cart-drawer'), cd = document.querySelector('cart-drawer');
        if (ncd && cd) cd.classList.toggle('is-empty', ncd.classList.contains('is-empty'));
      }
      if (s['cart-icon-bubble']) {
        var ib = document.getElementById('cart-icon-bubble'), nb = P.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (ib && nb) ib.innerHTML = nb.innerHTML;
      }
    }).catch(function () {});
  }
  function sync() {
    if (running) return; running = true;
    origFetch(R + '/cart.js', { credentials: 'same-origin', headers: hdrs() }).then(function (r) { return r.json(); }).then(function (cart) {
      var gifts = {}, packs = {}, picks = {};
      (cart.items || []).forEach(function (it) {
        var p = it.properties || {};
        if (p._bf_kind === 'en' && p._bf_for_id) { (gifts[p._bf_for_id] = gifts[p._bf_for_id] || []).push(it); }
        else if (p._bf_gift && p._bf_for_id) { (picks[p._bf_for_id] = picks[p._bf_for_id] || []).push(it); }
        else { packs[it.product_id] = (packs[it.product_id] || 0) + it.quantity; }
      });
      var updates = {}, n = 0;
      Object.keys(gifts).forEach(function (pid) {
        var want = packs[pid] || 0;
        gifts[pid].forEach(function (it, i) {
          var q = i === 0 ? want : 0;
          if (it.quantity !== q) { updates[it.key] = q; n++; }
        });
      });
      /* t30: cadoul 1–7 (ales din picker) rămâne în coș cât timp pachetul cumpărat e în coș; dispare doar dacă pachetul e scos */
      Object.keys(picks).forEach(function (pid) {
        if (packs[pid]) return;
        picks[pid].forEach(function (it) { if (it.quantity !== 0) { updates[it.key] = 0; n++; } });
      });
      /* t30: la prețuri egale Shopify dă 100% pe linia aflată mai sus în coș. Dacă reducerea a căzut pe pachetul cumpărat
         în loc de cadou, mutăm cadoul deasupra (îl scoatem și îl adăugăm din nou, cu aceleași proprietăți). Totalul nu se schimbă. */
      var readd = [];
      if (!n) Object.keys(picks).forEach(function (pid) {
        if (!packs[pid]) return;
        picks[pid].forEach(function (g) {
          if (g.final_line_price === 0 || g.quantity < 1) return;
          var packLine = (cart.items || []).filter(function (it) { var p = it.properties || {}; return String(it.product_id) === String(pid) && !p._bf_gift && !p._bf_kind; })[0];
          if (!packLine || packLine.final_line_price >= packLine.original_line_price) return;
          if (g.original_price > packLine.original_price) return;
          var k = 'bfGiftTop:' + g.key, t = 0; try { t = +sessionStorage.getItem(k) || 0; } catch (e) {}
          if (Date.now() - t < 60000) return; try { sessionStorage.setItem(k, Date.now()); } catch (e) {}
          updates[g.key] = 0; n++; readd.push({ id: g.variant_id, quantity: g.quantity, properties: g.properties });
        });
      });
      if (!n) return false;
      return origFetch(R + '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: hdrs(), body: JSON.stringify({ updates: updates }) })
        .then(function () { if (readd.length) return origFetch(R + '/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: hdrs(), body: JSON.stringify({ items: readd }) }); })
        .then(function () { return true; });
    }).then(function (changed) { if (changed) refreshUI(); }).catch(function () {}).finally(function () { running = false; });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 700); }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var mine = (h && (h['X-BF-Sync'] || (typeof h.get === 'function' && h.get('X-BF-Sync'))));
    var p = origFetch(input, init);
    if (!mine && /\/cart\/(add|change|update)(\.js|\.json)?/.test(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };
  document.addEventListener('bf:cart-sync', function () { schedule(50); });
  /* după „Cumpără acum” (EasySell modifică și el coșul): verificăm din nou */
  document.addEventListener('bf:gift-added', function () { setTimeout(function () { schedule(50); }, 2500); setTimeout(function () { schedule(50); }, 6000); });
  try {
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__bfu = u; return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () { var x = this; if (/\/cart\/(add|change|update)(\.js|\.json)?/.test(String(x.__bfu || ''))) x.addEventListener('loadend', function () { schedule(); }); return xs.apply(this, arguments); };
  } catch (e) {}
  if (/\/cart\/?$/.test(location.pathname)) schedule(300);
  /* și la deschiderea coșului / formularului EasySell */
  window.addEventListener('pageshow', function () { schedule(800); });
})();
